(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["static-product-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-reviews').forEach(function (root) {
      const list = root.querySelector('.product-reviews__list');
      const nav = root.querySelector('.product-reviews__pagination');
      if (!list || !nav) return;

      let perPage = parseInt(list.getAttribute('data-reviews-per-page'), 10);
      if (!perPage || perPage < 1) perPage = 8;

      const entries = list.querySelectorAll('.product-reviews__list__entry');
      if (entries.length <= perPage) return;

      const prevBtn = nav.querySelector('.product-reviews__pagination-btn--prev');
      const nextBtn = nav.querySelector('.product-reviews__pagination-btn--next');
      const info = nav.querySelector('.product-reviews__pagination-info');
      const total = entries.length;
      const totalPages = Math.ceil(total / perPage);
      let page = 1;

      function render() {
        const start = (page - 1) * perPage;
        const end = Math.min(start + perPage, total);
        entries.forEach(function (el, i) {
          if (i >= start && i < end) {
            el.classList.remove('product-reviews__list__entry--hidden');
            el.setAttribute('aria-hidden', 'false');
          } else {
            el.classList.add('product-reviews__list__entry--hidden');
            el.setAttribute('aria-hidden', 'true');
          }
        });
        if (info) {
          info.textContent = start + 1 + '–' + end + ' van ' + total;
        }
        if (prevBtn) prevBtn.disabled = page <= 1;
        if (nextBtn) nextBtn.disabled = page >= totalPages;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          if (page > 1) {
            page--;
            render();
          }
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          if (page < totalPages) {
            page++;
            render();
          }
        });
      }

      render();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
